import request from '@/utils/request'

export function getSpecifySunday(data) {
  return request({
    url: '/api/work/specify/sunday',
    method: 'post',
    data,
  })
}

// 曜日等条件指定マスタ一覧
export function queryWorkTimesList(data) {
  return request({
    url: `/api/weekdayConditionSpecify/queryWeekdayConditionSpecify`,
    method: 'post',
    data,
  })
}

// 曜日等条件指定マスタ一覧削除
export function weekdayConditionSpecifyDelete(data) {
  return request({
    url: `/api/weekdayConditionSpecify/deleteWeekdayConditionSpecify`,
    method: 'post',
    data,
  })
}

// 曜日等条件指定マスタ更新 新規作成
export function updateWeekdayConditionSpecify(data) {
  return request({
    url: `/api/weekdayConditionSpecify/updateWeekdayConditionSpecify`,
    method: 'put',
    data,
  })
}

// （曜日等条件指定基本詳細
export function queryWeekdayConditionSpecifyDetail(data) {
  return request({
    url: `/api/weekdayConditionSpecify/queryWeekdayConditionSpecifyDetail`,
    method: 'post',
    data,
  })
}

// （曜日等条件指定マスタスポット一覧
export function queryWeekdayConditionSpecifySpot(data) {
  return request({
    url: `/api/weekdayConditionSpecify/queryWeekdayConditionSpecifySpot`,
    method: 'post',
    data,
  })
}

// 曜日等条件指定マスタスポット更新
export function updateWeekdayConditionSpecifySpot(data) {
  return request({
    url: `/api/weekdayConditionSpecify/updateWeekdayConditionSpecifySpot`,
    method: 'put',
    data,
  })
}

// 共通 建物・FM情報
export function queryBuildingInformation(query) {
  return request({
    url: `/api/workingPlanAndResultRc/queryBuildingInformation/${query.buildingCd}?sectionCd=${query.sectionCd}`,
    method: 'get',
    query,
  })
}

// 共通 FM情報取得
export function queryFmInformation(query) {
  return request({
    url: `/api/workingPlanAndResultRc/queryFmInformation/${query.buildingCd}`,
    method: 'get',
    query,
  })
}
